import React, { useState } from 'react'
import "./contactBanner.css"
import Img from "../../assets/images/hr-service-Banner.png"
import { Link } from 'react-router-dom';
import WA from "../../assets/images/whatsapp.png"
import Mail from "../../assets/images/mailicon.png"

const ContactBanner = ({ isRtl }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const content = isRtl
        ? {
            heading: "تلبي جميع الخدمات الحكومية للمنشآت و الموظفين",
            paragraph1: "لا مزيد من المعاناة في تخليص المعاملات ومتابعتها، مع تـوفــيـر جـمـيع الأوراق الرسـمــيـة المطـلوبـة للمـنــشآت و الموظفين بكل سهولة.",
            buttonText: "اطلب عرض تجريبي",
        }
        : {
            heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
            paragraph1:
                "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
            buttonText: "GET A FREE DEMO",
        };
    return (
        <section className={`SimpleBannerSection cotactBannerSec ${isRtl ? "rtl" : ""}`}>
            <div className="">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-right">
                        <div className="banner-content">
                            <h1>HR PASS</h1>
                            <h1>{content.heading}</h1>
                            <p>{content.paragraph1}</p>
                            <p>{content.paragraph2}</p>

                            <Link to="https://wa.me/+971503771775" className="contactItem mb-4">
                                <img src={WA} alt="" />
                                <p>
                                    +971 50 3771775
                                </p>
                            </Link>
                            <Link to="mailto:info@hrpass.ae" className="contactItem">
                                <img src={Mail} alt="" />
                                <p>
                                    info@hrpass.ae
                                </p>
                            </Link>

                            {/* <button type="button" className="darkBrownBtn" onClick={handleShow}>
                                {content.buttonText}
                            </button> */}
                        </div>
                    </div>
                    <div className="col-lg-2 d-none d-lg-flex">

                    </div>
                    <div className="col-lg-5 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-left">
                        <img src={Img} alt="" className='bannerImg' />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactBanner